import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "premium-phones--modal" }
const _hoisted_2 = { class: "premium-phones--modal-title" }
const _hoisted_3 = { class: "footnote color-text-primary" }
const _hoisted_4 = { class: "h4 color-text-primary" }
const _hoisted_5 = { class: "premium-phones--modal-price" }
const _hoisted_6 = { class: "caption-navbar color-text-primary" }
const _hoisted_7 = { class: "premium-phones--modal" }
const _hoisted_8 = { class: "premium-phones--modal-title" }
const _hoisted_9 = { class: "footnote color-text-primary" }
const _hoisted_10 = { class: "h4 color-text-primary" }
const _hoisted_11 = { class: "color-grey-light" }
const _hoisted_12 = { class: "premium-phones--modal-progress" }
const _hoisted_13 = { class: "premium-phones--modal" }
const _hoisted_14 = { class: "premium-phones--modal-title" }
const _hoisted_15 = { class: "footnote color-text-primary" }
const _hoisted_16 = { class: "h4 color-text-primary" }
const _hoisted_17 = { class: "color-grey-light" }
const _hoisted_18 = { class: "premium-phones--modal-progress" }
const _hoisted_19 = { class: "premium-phones--modal" }
const _hoisted_20 = { class: "premium-phones--modal-title" }
const _hoisted_21 = { class: "footnote color-text-primary" }
const _hoisted_22 = { class: "h4 color-text-primary" }
const _hoisted_23 = { class: "color-grey-light" }
const _hoisted_24 = { class: "premium-phones--modal-progress" }

import BaseModal from "@/components/base/BaseModal.vue";
import BaseProgressBar from "@/components/base/BaseProgressBar.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PremiumPhonesModals',
  props: {
    activeNumber: {},
    activeNumberPrice: {},
    activeNumberType: {},
    errorModal: { type: Boolean },
    errorSixMonthsModal: { type: Boolean },
    formatPhone: { type: Function },
    isLoadingChangeNumber: { type: Boolean },
    openModal: { type: Boolean },
    openModalFirstPayment: { type: Boolean },
    openModalLowMoney: { type: Boolean },
    openModalSecondPayment: { type: Boolean },
    openModalTwoParts: { type: Boolean },
    successModal: { type: Boolean },
    walletAmount: {},
    walletAmountCalc: {}
  },
  emits: ["close-confirm", "close-error", "close-first-payment", "close-low-money", "close-second-payment", "close-six-months-error", "close-success", "close-two-parts", "confirm", "continue-to-first-payment", "continue-to-second-payment", "to-payment"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: ".root" }, [
    (_ctx.openModal)
      ? (_openBlock(), _createBlock(BaseModal, {
          key: 0,
          title: _ctx.$t('premium.modals.confirmTitle'),
          "main-btn-title": _ctx.$t('premium.modals.confirmAction'),
          mainBtnLoading: _ctx.isLoadingChangeNumber,
          onAction: _cache[0] || (_cache[0] = ($event: any) => (emit('confirm', _ctx.activeNumber as number, _ctx.activeNumberType))),
          onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close-confirm')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("premium.modals.selectedNumber")), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.formatPhone(String(_ctx.activeNumber))), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.activeNumberPrice) + " ₽ ", 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["title", "main-btn-title", "mainBtnLoading"]))
      : _createCommentVNode("", true),
    (_ctx.openModalLowMoney)
      ? (_openBlock(), _createBlock(BaseModal, {
          key: 1,
          title: _ctx.$t('premium.modals.lowMoneyTitle'),
          "main-btn-title": 
        _ctx.$t('premium.modals.topUpOn', {
          amount: (_ctx.activeNumberPrice || 0) - (_ctx.walletAmountCalc || 0),
        })
      ,
          onAction: _cache[2] || (_cache[2] = ($event: any) => (emit('to-payment'))),
          onClose: _cache[3] || (_cache[3] = ($event: any) => (emit('close-low-money')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("premium.modals.yourBalance")), 1),
                _createElementVNode("p", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.walletAmountCalc) + "₽ / ", 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.activeNumberPrice) + "₽", 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(BaseProgressBar, {
                    "current-amount": _ctx.walletAmount as number,
                    "max-amount": _ctx.activeNumberPrice as number
                  }, null, 8, ["current-amount", "max-amount"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["title", "main-btn-title"]))
      : _createCommentVNode("", true),
    (_ctx.openModalTwoParts)
      ? (_openBlock(), _createBlock(BaseModal, {
          key: 2,
          title: _ctx.$t('premium.modals.twoPartsTitle'),
          "main-btn-title": _ctx.$t('common.actions.continue'),
          text: _ctx.$t('premium.modals.twoPartsText'),
          onAction: _cache[4] || (_cache[4] = ($event: any) => (emit('continue-to-first-payment'))),
          onClose: _cache[5] || (_cache[5] = ($event: any) => (emit('close-two-parts')))
        }, null, 8, ["title", "main-btn-title", "text"]))
      : _createCommentVNode("", true),
    (_ctx.openModalFirstPayment)
      ? (_openBlock(), _createBlock(BaseModal, {
          key: 3,
          title: _ctx.$t('premium.modals.firstPaymentTitle'),
          "main-btn-title": _ctx.$t('premium.modals.firstPaymentAction'),
          onAction: _cache[6] || (_cache[6] = ($event: any) => (emit('continue-to-second-payment'))),
          onClose: _cache[7] || (_cache[7] = ($event: any) => (emit('close-first-payment')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("premium.modals.yourBalance")), 1),
                _createElementVNode("p", _hoisted_16, [
                  _createTextVNode(_toDisplayString(_ctx.walletAmount) + "₽ / ", 1),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.activeNumberPrice) + "₽", 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(BaseProgressBar, {
                    "current-amount": _ctx.walletAmount as number,
                    "max-amount": _ctx.activeNumberPrice as number
                  }, null, 8, ["current-amount", "max-amount"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["title", "main-btn-title"]))
      : _createCommentVNode("", true),
    (_ctx.openModalSecondPayment)
      ? (_openBlock(), _createBlock(BaseModal, {
          key: 4,
          title: _ctx.$t('premium.modals.secondPaymentTitle'),
          "main-btn-title": 
        _ctx.$t('premium.modals.topUpOn', {
          amount: (_ctx.activeNumberPrice || 0) - (_ctx.walletAmount || 0),
        })
      ,
          onAction: _cache[8] || (_cache[8] = ($event: any) => (emit('to-payment'))),
          onClose: _cache[9] || (_cache[9] = ($event: any) => (emit('close-second-payment')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("premium.modals.yourBalance")), 1),
                _createElementVNode("p", _hoisted_22, [
                  _createTextVNode(_toDisplayString(_ctx.walletAmount) + "₽ / ", 1),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.activeNumberPrice) + "₽", 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(BaseProgressBar, {
                    "current-amount": _ctx.walletAmount as number,
                    "max-amount": _ctx.activeNumberPrice as number
                  }, null, 8, ["current-amount", "max-amount"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["title", "main-btn-title"]))
      : _createCommentVNode("", true),
    (_ctx.successModal)
      ? (_openBlock(), _createBlock(BaseModal, {
          key: 5,
          title: _ctx.$t('premium.modals.successTitle'),
          "main-btn-title": _ctx.$t('common.actions.ok'),
          "is-success-modal": true,
          onAction: _cache[10] || (_cache[10] = ($event: any) => (emit('close-success'))),
          onClose: _cache[11] || (_cache[11] = ($event: any) => (emit('close-success')))
        }, null, 8, ["title", "main-btn-title"]))
      : _createCommentVNode("", true),
    (_ctx.errorModal)
      ? (_openBlock(), _createBlock(BaseModal, {
          key: 6,
          title: _ctx.$t('premium.modals.errorBusyTitle'),
          "main-btn-title": _ctx.$t('common.actions.continue'),
          onAction: _cache[12] || (_cache[12] = ($event: any) => (emit('close-error'))),
          onClose: _cache[13] || (_cache[13] = ($event: any) => (emit('close-error')))
        }, null, 8, ["title", "main-btn-title"]))
      : _createCommentVNode("", true),
    (_ctx.errorSixMonthsModal)
      ? (_openBlock(), _createBlock(BaseModal, {
          key: 7,
          title: _ctx.$t('premium.modals.errorSixMonthsTitle'),
          "main-btn-title": _ctx.$t('common.actions.continue'),
          onAction: _cache[14] || (_cache[14] = ($event: any) => (emit('close-six-months-error'))),
          onClose: _cache[15] || (_cache[15] = ($event: any) => (emit('close-six-months-error')))
        }, null, 8, ["title", "main-btn-title"]))
      : _createCommentVNode("", true)
  ]))
}
}

})